import { createConsoleLogger } from '@dossierhq/core';

const logger = createConsoleLogger(console);

export const SERVER_LOGGER = logger;
export const SESSION_LOGGER = logger;
